<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("inventory_adjustment_voucher")}}</h4>
                <p class="text-subtitle-1">{{$t("adjust_stock_in_inventory")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <StockJournalView type="STOCK_ADJUSTMENT"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import StockJournalView from './StockJournalView';
export default {
    name: "StockAdjustmentView",
    components: { StockJournalView },
    data() {
        return {
            breadcrumbs: [
                { text: "Inventory Management" },
                { text: "Stock Movement" },
                { text: "Inventory Adjustment" }
            ]
        }
    }
}
</script>

<style>

</style>